export const generateUrl = ({ url, version = DEFAULT_API_VERSION }) => {
  const versionApiUrl = version ? `/${version}` : '';

  return `${versionApiUrl}${url}`;
};
